import React from "react";
import { CONFIG } from "../config";
import { useTimer } from "../context/TimerContext";
import { Timer, AlertCircle } from "lucide-react";

export default function UrgencyBar() {
  const { formattedTime, isExpired } = useTimer();

  return (
    <div className="sticky top-0 z-50 bg-brand-red text-white py-2 px-4 shadow-md font-sans text-xs md:text-sm">
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-2">
        {/* Element 1: Left */}
        <div className="flex items-center gap-2 font-semibold tracking-wider text-center sm:text-left" data-testid="urgency-bar-headline">
          <span className="inline-block w-2 h-2 rounded-full bg-brand-yellow animate-ping"></span>
          <span className="uppercase">
            STOP! NEVER PAY A DEBT COLLECTOR!
          </span>
        </div>

        {/* Element 2: Center */}
        <div className="hidden md:flex items-center gap-1.5 text-brand-yellow font-bold" data-testid="urgency-bar-price-alert">
          <AlertCircle className="w-4 h-4" />
          <span>ACTIVATE THE KILL SWITCH TODAY: ${CONFIG.currentPrice}</span>
        </div>

        {/* Element 3: Right */}
        <div className="flex items-center gap-1.5 bg-black/30 px-3 py-1 rounded-full border border-white/20 font-bold" data-testid="urgency-bar-timer">
          <Timer className="w-3.5 h-3.5 text-brand-yellow" />
          <span className="font-mono text-brand-yellow">
            {isExpired ? `PRICE MAY RETURN TO $${CONFIG.regularPrice} WITHOUT NOTICE` : `START YOUR NEXT MOVE: ${formattedTime}`}
          </span>
        </div>
      </div>
    </div>
  );
}
